import { Pipe, PipeTransform } from '@angular/core';
import { MetaService } from '@bo-client/core/api/meta-service';

@Pipe({
  name: 'orderState'
})
export class OrderStatePipe implements PipeTransform {
  constructor(private metaService: MetaService) {
    //
  }
  transform(value: string) {
    // Todo: Überprüfen, ob sowas nicht einheitlich mit dem MetaService sein sollte -> Ein Wert hatte einen Schreibfehler und wurde deswegen nicht gemappt
    switch (value) {
      case 'creating_sap':
        return 'Auftrag in Erstellung (SAP)';
      case 'confirmation_requested_by_mail':
        return 'Angebot via Mail verschickt';
      case 'error_creating_order':
        return 'Fehler bei Auftragsanlage';
      case 'under_construction':
        return 'In Bau';
      default:
        return this.metaService.getStateFilterOptions().find((state) => state.state === value)?.name || value;
    }
  }
}
